import { FaHammer, FaTractor, FaCubes, FaWrench, FaRoad, FaTruck, FaBoxOpen, FaLayerGroup } from 'react-icons/fa';
import { GiRoad, GiCompactDisc, GiSandCastle, GiStoneBlock, GiStonePile, GiMining } from 'react-icons/gi';

export const servicesData = [
  {
    id: 'building-demolition',
    category: 'services',
    title: 'Building Demolition',
    shortDesc: 'Professional building demolition services in Coimbatore — safe, fast, and fully licensed. We handle residential & commercial demolition with modern equipment across all Coimbatore areas.',
    icon: <FaHammer />,
    image: '/new_image/Buiding Demolish.jpg',
    fullDescription: `Professional building demolition services in Coimbatore with a focus on safety, efficiency, and environmental responsibility. Our experienced team handles residential, commercial, and industrial demolition projects of all sizes.`,
    features: [
      'Safe and controlled demolition',
      'Modern equipment and machinery',
      'Debris removal and site cleanup',
      'Licensed and insured services',
      'Eco-friendly waste disposal',
      'Minimal disruption to surroundings'
    ],
    benefits: [
      'Quick project completion',
      'Cost-effective solutions',
      'Complete safety compliance',
      'Professional team',
      'Insurance coverage'
    ],
    process: [
      'Site inspection and assessment',
      'Detailed demolition plan',
      'Safety measures implementation',
      'Controlled demolition execution',
      'Debris removal and recycling',
      'Final site cleanup'
    ]
  },
  {
    id: 'earthwork',
    category: 'services',
    title: 'Earth Work',
    shortDesc: 'Top earthwork contractors in Coimbatore. Expert excavation, site preparation, and foundation work for projects across Coimbatore.',
    icon: <FaTractor />,
    image: '/new_image/Excavator for rent.jpg',
    fullDescription: `Comprehensive earthwork solutions in Coimbatore. We provide expert excavation, site preparation, and foundation work for residential, commercial, and infrastructure projects.`,
    features: [
      'Soil Nailing - Slope stabilization',
      'Reinforced Cement Concrete work',
      'Specialized earthwork services',
      'Excavation and grading',
      'Site leveling and preparation',
      'Foundation earthwork'
    ],
    benefits: [
      'Experienced operators',
      'Modern machinery fleet',
      'Precise execution',
      'Timely completion',
      'Quality assurance'
    ],
    process: [
      'Site survey and soil testing',
      'Earthwork planning',
      'Equipment mobilization',
      'Excavation and grading',
      'Compaction and leveling',
      'Quality inspection'
    ]
  },
  {
    id: 'building-materials',
    category: 'services',
    title: 'Building Material Suppliers',
    shortDesc: 'Best building material suppliers in Coimbatore. We supply Hi-tech M-sand, high-quality construction wire, and precision cut bricks — delivered on time to your site in Coimbatore.',
    icon: <FaCubes />,
    image: '/new_image/Building materials.jpg',
    fullDescription: `Your trusted building materials supplier in Coimbatore. We supply premium quality Hi-tech M-sand, superior construction wire, and precision-cut bricks. All materials are tested for quality and delivered on time to your construction site.`,
    features: [
      'Hi-tech M-sand - Superior quality',
      'High-quality construction wire',
      'Precision cut bricks',
      'Quality tested materials',
      'Timely delivery',
      'Competitive pricing'
    ],
    benefits: [
      'Premium quality assurance',
      'Best market prices',
      'Bulk order discounts',
      'Reliable delivery',
      'Technical support'
    ],
    process: [
      'Material requirement analysis',
      'Quality specification',
      'Order confirmation',
      'Quality testing',
      'Timely delivery',
      'After-sales support'
    ]
  },

  // Rental Services
  {
    id: 'excavator-breaker-rent',
    category: 'rentals',
    title: 'Excavator Breaker for Rent',
    shortDesc: 'Rent excavator breaker in Coimbatore for rock breaking, concrete demolition, and hard surface excavation. Hourly & daily hire available across Coimbatore.',
    icon: <FaWrench />,
    image: '/new_image/Excavator breaker for rent.jpg',
    fullDescription: `Hire an excavator breaker in Coimbatore for powerful rock breaking, concrete demolition, and hard-surface excavation. Our well-maintained hydraulic breaker attachments are available on hourly, daily, and weekly rental basis across Coimbatore and surrounding areas.`,
    features: [
      'High-impact hydraulic breaker attachment',
      'Suitable for rock, concrete & hard soil',
      'Hourly, daily & weekly rental plans',
      'Experienced operator available',
      'Well-maintained equipment',
      'Available across Coimbatore'
    ],
    benefits: [
      'Cost-effective rental rates',
      'No ownership maintenance cost',
      'Flexible hire duration',
      'Prompt mobilization',
      'Skilled operator on request'
    ],
    process: [
      'Enquiry & site assessment',
      'Rental plan confirmation',
      'Equipment mobilization to site',
      'Operator briefing & safety check',
      'Work execution',
      'Equipment return & billing'
    ]
  },
  {
    id: 'mini-road-roller-rent',
    category: 'rentals',
    title: 'Mini Road Roller for Rent',
    shortDesc: 'Mini road roller rental in Coimbatore for road laying, pathway compaction, and small-area paving. Flexible hire rates for contractors across Coimbatore.',
    icon: <FaRoad />,
    image: '/new_image/Mini road roller for rent.jpg',
    fullDescription: `Rent a mini road roller in Coimbatore for efficient compaction of roads, pathways, driveways, and small paving projects. Our compact rollers are ideal for tight spaces and residential road works across Coimbatore.`,
    features: [
      'Compact design for tight spaces',
      'Ideal for roads, pathways & driveways',
      'Smooth & padfoot drum options',
      'Hourly, daily & weekly hire',
      'Operator available on request',
      'Serviced and road-ready equipment'
    ],
    benefits: [
      'Affordable rental rates',
      'Easy maneuverability',
      'Reduces project cost',
      'Quick site mobilization',
      'Suitable for small & medium projects'
    ],
    process: [
      'Site requirement discussion',
      'Roller type selection',
      'Rental agreement',
      'Equipment delivery to site',
      'Compaction work execution',
      'Equipment pickup & final billing'
    ]
  },
  {
    id: 'soil-compactor-rent',
    category: 'rentals',
    title: 'Soil Compactor for Rent',
    shortDesc: 'Soil compactor rental in Coimbatore for foundation compaction, trench backfill, and earthwork projects. Best rates for daily & weekly hire in Coimbatore.',
    icon: <GiCompactDisc />,
    image: '/new_image/Soil compactor for rent.jpg',
    fullDescription: `Hire a soil compactor in Coimbatore for foundation preparation, trench backfilling, and earthwork compaction. Our plate compactors and vibratory rollers ensure optimal soil density for safe and durable construction across Coimbatore.`,
    features: [
      'Plate compactor & vibratory roller options',
      'Suitable for soil, gravel & sand',
      'Foundation & trench compaction',
      'Hourly, daily & weekly rental',
      'Well-maintained machinery',
      'Operator available on request'
    ],
    benefits: [
      'Ensures proper soil density',
      'Reduces settlement risk',
      'Cost-effective hire rates',
      'Fast mobilization',
      'Flexible rental duration'
    ],
    process: [
      'Site soil assessment',
      'Compactor type selection',
      'Rental confirmation',
      'Equipment delivery',
      'Compaction execution',
      'Inspection & billing'
    ]
  },
  {
    id: 'excavator-rent',
    category: 'rentals',
    title: 'Excavator for Rent',
    shortDesc: 'Excavator rental in Coimbatore for digging, trenching, and earthmoving. Hire JCB-class excavators by the hour or day across Coimbatore construction sites.',
    icon: <FaTractor />,
    image: '/new_image/Excavator for rent.jpg',
    fullDescription: `Rent an excavator in Coimbatore for all types of digging, trenching, foundation excavation, and earthmoving work. We offer a range of excavator sizes suitable for residential, commercial, and infrastructure projects across Coimbatore.`,
    features: [
      'Multiple excavator sizes available',
      'Suitable for digging, trenching & earthmoving',
      'Experienced operators provided',
      'Hourly, daily & weekly hire',
      'GPS-tracked equipment',
      'Available across Coimbatore'
    ],
    benefits: [
      'Flexible rental plans',
      'No maintenance burden',
      'Skilled operators on request',
      'Prompt site mobilization',
      'Competitive pricing'
    ],
    process: [
      'Site visit & requirement analysis',
      'Excavator size selection',
      'Rental agreement',
      'Equipment & operator deployment',
      'Excavation work',
      'Site handover & billing'
    ]
  },
  {
    id: 'jcb-rent',
    category: 'rentals',
    title: 'JCB for Rent',
    shortDesc: 'JCB rental in Coimbatore for digging, loading, and site clearance. Hire JCB backhoe loaders at the best rates for construction projects across Coimbatore.',
    icon: <FaTractor />,
    image: '/new_image/JCB for rent.jpg',
    fullDescription: `Hire a JCB backhoe loader in Coimbatore for digging, loading, site clearance, and material handling. Our JCBs are well-maintained and available with experienced operators for all types of construction and civil work across Coimbatore.`,
    features: [
      'JCB backhoe loader rental',
      'Digging, loading & site clearance',
      'Experienced JCB operators',
      'Hourly, daily & weekly hire',
      'Well-serviced machinery',
      'Available across Coimbatore'
    ],
    benefits: [
      'Versatile multi-purpose machine',
      'Best rental rates in Coimbatore',
      'Quick mobilization',
      'Operator included option',
      'Reliable and efficient'
    ],
    process: [
      'Requirement discussion',
      'JCB model selection',
      'Rental confirmation',
      'Equipment deployment',
      'Work execution',
      'Billing & equipment return'
    ]
  },
  {
    id: 'jcb-breaker-rent',
    category: 'rentals',
    title: 'JCB Breaker for Rent',
    shortDesc: 'JCB breaker rental in Coimbatore for concrete breaking, rock demolition, and road cutting. Hire JCB with hydraulic breaker at best rates across Coimbatore.',
    icon: <FaHammer />,
    image: '/new_image/JCB Breaker for rent.jpg',
    fullDescription: `Rent a JCB with hydraulic breaker attachment in Coimbatore for concrete demolition, rock breaking, and road cutting. Our JCB breakers are ideal for demolition and renovation projects across Coimbatore and nearby areas.`,
    features: [
      'JCB with hydraulic breaker attachment',
      'Concrete, rock & road breaking',
      'High-impact breaking power',
      'Hourly, daily & weekly hire',
      'Experienced operator available',
      'Prompt site mobilization'
    ],
    benefits: [
      'Powerful breaking capability',
      'Reduces manual labour cost',
      'Flexible hire duration',
      'Competitive rates',
      'Safe and efficient operation'
    ],
    process: [
      'Site inspection',
      'Breaking requirement assessment',
      'Rental plan confirmation',
      'Equipment mobilization',
      'Breaking work execution',
      'Site cleanup & billing'
    ]
  },
  {
    id: 'tipper-rent',
    category: 'rentals',
    title: 'TIPPER for Rent',
    shortDesc: 'Tipper truck rental in Coimbatore for sand, soil, debris, and construction material transport. Hire tippers by the trip or day across Coimbatore.',
    icon: <FaTruck />,
    image: '/new_image/Building materials.jpg',
    fullDescription: `Hire a tipper truck in Coimbatore for transporting sand, soil, gravel, demolition debris, and construction materials. Our tippers are available for single trips, daily hire, and long-term contracts across Coimbatore and surrounding districts.`,
    features: [
      'Various tipper capacities available',
      'Sand, soil, gravel & debris transport',
      'Single trip & daily hire options',
      'Experienced drivers',
      'GPS-tracked vehicles',
      'Available across Coimbatore'
    ],
    benefits: [
      'Reliable material transport',
      'Competitive per-trip rates',
      'Timely delivery',
      'Bulk transport capability',
      'Flexible scheduling'
    ],
    process: [
      'Transport requirement discussion',
      'Tipper capacity selection',
      'Route & schedule planning',
      'Loading & dispatch',
      'Material delivery',
      'Trip completion & billing'
    ]
  },
  {
    id: 'open-platform-truck-rent',
    category: 'rentals',
    title: 'Open Platform Truck for Rent',
    shortDesc: 'Open platform truck rental in Coimbatore for heavy material, machinery, and equipment transport. Hire flatbed trucks at best rates across Coimbatore.',
    icon: <FaBoxOpen />,
    image: '/new_image/Building materials.jpg',
    fullDescription: `Rent an open platform (flatbed) truck in Coimbatore for transporting heavy construction materials, machinery, steel, and oversized loads. Our open platform trucks are ideal for construction sites and industrial transport across Coimbatore.`,
    features: [
      'Open flatbed platform for oversized loads',
      'Heavy machinery & material transport',
      'Multiple tonnage options',
      'Experienced drivers',
      'Daily & weekly hire available',
      'Available across Coimbatore'
    ],
    benefits: [
      'Handles oversized & heavy loads',
      'Cost-effective transport solution',
      'Flexible hire duration',
      'Reliable and on-time',
      'Wide coverage area'
    ],
    process: [
      'Load requirement assessment',
      'Truck capacity selection',
      'Hire agreement',
      'Loading & securing cargo',
      'Transport & delivery',
      'Billing & completion'
    ]
  },
  {
    id: 'bobcat-rent',
    category: 'rentals',
    title: 'BOBCAT for Rent',
    shortDesc: 'Bobcat skid steer loader rental in Coimbatore for digging, grading, and material handling in confined spaces. Hire bobcat at best rates across Coimbatore.',
    icon: <GiRoad />,
    image: '/new_image/Bobcat for rent.jpg',
    fullDescription: `Hire a Bobcat skid steer loader in Coimbatore for digging, grading, landscaping, and material handling in tight and confined spaces. Our Bobcats are perfect for indoor demolition, narrow site access, and precision earthwork across Coimbatore.`,
    features: [
      'Compact skid steer loader',
      'Ideal for confined & tight spaces',
      'Multiple attachments available',
      'Digging, grading & material handling',
      'Hourly, daily & weekly hire',
      'Operator available on request'
    ],
    benefits: [
      'Works in tight spaces',
      'Versatile with multiple attachments',
      'Reduces manual labour',
      'Affordable rental rates',
      'Quick mobilization in Coimbatore'
    ],
    process: [
      'Site access assessment',
      'Attachment selection',
      'Rental confirmation',
      'Equipment delivery',
      'Work execution',
      'Equipment return & billing'
    ]
  }
];

// Building Materials
const buildingMaterialsEntries = [
  {
    id: 'm-sand',
    category: 'materials',
    title: 'M Sand',
    shortDesc: 'Premium M Sand (Manufactured Sand) supplier in Coimbatore. High-quality M sand for plastering, concrete, and masonry work — delivered to your site.',
    icon: <GiSandCastle />,
    image: '/new_image/M-Sand.jpg',
    fullDescription: `M Sand (Manufactured Sand) is a high-quality alternative to river sand, produced by crushing granite. We supply premium M Sand in Coimbatore for all construction needs including plastering, concrete mixing, and masonry work. Our M Sand meets IS standards and is free from impurities.`,
    features: [
      'Manufactured from crushed granite',
      'Consistent gradation & quality',
      'Free from silt and organic matter',
      'Ideal for plastering & concrete',
      'IS standard compliant',
      'Bulk supply available'
    ],
    benefits: [
      'Better workability than river sand',
      'Eco-friendly & sustainable',
      'Consistent quality every batch',
      'Competitive pricing',
      'Timely delivery across Coimbatore'
    ],
    process: [
      'Quantity requirement discussion',
      'Quality grade selection',
      'Order confirmation',
      'Quality check before dispatch',
      'Delivery to site',
      'After-sales support'
    ]
  },
  {
    id: 'p-sand',
    category: 'materials',
    title: 'P Sand',
    shortDesc: 'P Sand (Plastering Sand) supplier in Coimbatore. Fine-grade manufactured sand for smooth plastering and finishing work — best rates in Coimbatore.',
    icon: <GiSandCastle />,
    image: '/new_image/P-Sand.jpg',
    fullDescription: `P Sand (Plastering Sand) is a finely graded manufactured sand specifically designed for plastering and finishing work. We supply high-quality P Sand in Coimbatore that gives smooth, crack-free plaster finishes for residential and commercial buildings.`,
    features: [
      'Fine gradation for smooth finish',
      'Specifically designed for plastering',
      'Low silt content',
      'Uniform particle size',
      'IS 1542 standard compliant',
      'Bulk & retail supply'
    ],
    benefits: [
      'Smooth crack-free plaster finish',
      'Reduces water absorption',
      'Better bonding strength',
      'Cost-effective solution',
      'Prompt delivery in Coimbatore'
    ],
    process: [
      'Plastering requirement assessment',
      'Quantity estimation',
      'Order placement',
      'Quality verification',
      'Site delivery',
      'Technical guidance if needed'
    ]
  },
  {
    id: 'wet-mix-macadam',
    category: 'materials',
    title: 'Wet Mix Macadam',
    shortDesc: 'Wet Mix Macadam (WMM) supplier in Coimbatore for road base and sub-base construction. Quality WMM material for highways and internal roads across Coimbatore.',
    icon: <GiStoneBlock />,
    image: '/new_image/Wet mix Macadam.jpg',
    fullDescription: `Wet Mix Macadam (WMM) is a well-graded crushed aggregate material used as a base or sub-base layer in road construction. We supply quality WMM in Coimbatore for highways, internal roads, and parking areas, ensuring strong and durable road foundations.`,
    features: [
      'Well-graded crushed aggregate mix',
      'Suitable for road base & sub-base',
      'Meets MoRTH specifications',
      'Consistent gradation',
      'Bulk supply available',
      'Delivered to site in Coimbatore'
    ],
    benefits: [
      'Strong road foundation',
      'Excellent load-bearing capacity',
      'Reduces road maintenance cost',
      'Durable and long-lasting',
      'Timely bulk delivery'
    ],
    process: [
      'Road project requirement discussion',
      'Quantity & grade estimation',
      'Order confirmation',
      'Quality testing',
      'Bulk delivery to site',
      'Technical support'
    ]
  },
  {
    id: 'coarse-aggregates',
    category: 'materials',
    title: 'Coarse Aggregates',
    shortDesc: 'Coarse aggregates supplier in Coimbatore. Quality 6mm, 12mm, 20mm, and 40mm crushed stone aggregates for concrete and construction — best rates in Coimbatore.',
    icon: <GiStonePile />,
    image: '/new_image/Coarse aggregates.jpg',
    fullDescription: `We supply premium quality coarse aggregates (crushed stone jelly) in Coimbatore in various sizes — 6mm, 12mm, 20mm, and 40mm — for all types of concrete work, road construction, and drainage applications. All aggregates are tested for strength and durability.`,
    features: [
      'Available in 6mm, 12mm, 20mm, 40mm sizes',
      'Crushed granite aggregates',
      'High crushing strength',
      'Low water absorption',
      'IS 383 standard compliant',
      'Bulk supply & delivery'
    ],
    benefits: [
      'High-strength concrete mix',
      'Consistent size & quality',
      'Suitable for all construction types',
      'Competitive bulk pricing',
      'Reliable delivery in Coimbatore'
    ],
    process: [
      'Size & quantity requirement',
      'Grade selection',
      'Order confirmation',
      'Quality inspection',
      'Delivery to site',
      'Post-delivery support'
    ]
  },
  {
    id: 'red-soil',
    category: 'materials',
    title: 'Red Soil',
    shortDesc: 'Red soil supplier in Coimbatore for filling, landscaping, and garden work. Quality red earth delivered in bulk to your site across Coimbatore.',
    icon: <GiMining />,
    image: '/new_image/Red soil.jpg',
    fullDescription: `We supply quality red soil in Coimbatore for site filling, landscaping, garden beds, and earthwork applications. Our red earth is sourced from quality locations and delivered in bulk via tipper trucks to your site across Coimbatore and surrounding areas.`,
    features: [
      'Quality red earth / laterite soil',
      'Suitable for filling & landscaping',
      'Garden & agricultural use',
      'Bulk tipper delivery',
      'Available in any quantity',
      'Delivered across Coimbatore'
    ],
    benefits: [
      'Good drainage properties',
      'Ideal for garden & landscaping',
      'Cost-effective filling material',
      'Prompt bulk delivery',
      'Flexible quantity orders'
    ],
    process: [
      'Quantity & purpose discussion',
      'Site location confirmation',
      'Order placement',
      'Loading & dispatch',
      'Tipper delivery to site',
      'Completion & billing'
    ]
  },
  {
    id: 'gravel-filling',
    category: 'materials',
    title: 'Gravel Filling',
    shortDesc: 'Gravel filling material supplier in Coimbatore for foundation filling, drainage, and road sub-base. Quality gravel delivered in bulk across Coimbatore.',
    icon: <GiStoneBlock />,
    image: '/new_image/Gravel filling.jpg',
    fullDescription: `We supply quality gravel filling material in Coimbatore for foundation filling, drainage layers, road sub-base, and site leveling. Our gravel is well-graded and delivered in bulk via tipper trucks to construction sites across Coimbatore.`,
    features: [
      'Well-graded gravel material',
      'Suitable for foundation & drainage',
      'Road sub-base application',
      'Site leveling & filling',
      'Bulk tipper delivery',
      'Available across Coimbatore'
    ],
    benefits: [
      'Excellent drainage capability',
      'Strong load-bearing base',
      'Cost-effective filling solution',
      'Bulk quantity available',
      'Timely delivery'
    ],
    process: [
      'Filling requirement assessment',
      'Quantity estimation',
      'Order confirmation',
      'Loading & dispatch',
      'Delivery to site',
      'Billing & completion'
    ]
  }
];

export { buildingMaterialsEntries };

// Merge all services
buildingMaterialsEntries.forEach(e => servicesData.push(e));

export const materialsDetails = {
  msand: {
    name: 'Hi-tech M-Sand',
    description: 'Premium manufactured sand for all construction needs',
    features: [
      'Consistent quality and gradation',
      'Free from impurities',
      'Better workability',
      'Eco-friendly alternative to river sand',
      'Tested for strength and durability'
    ]
  },
  wire: {
    name: 'High Quality Wire',
    description: 'Superior construction wire for reinforcement',
    features: [
      'High tensile strength',
      'Corrosion resistant',
      'Uniform thickness',
      'Quality certified',
      'Various gauges available'
    ]
  },
  bricks: {
    name: 'Cut Bricks',
    description: 'Precision cut bricks for perfect construction',
    features: [
      'Uniform size and shape',
      'High compressive strength',
      'Low water absorption',
      'Smooth finish',
      'Cost-effective'
    ]
  }
};
